module.exports = {
	"ha": "vcha",
	"id": 5.3,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by Age Category, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 69.5,
						"dataLabels": {
							"enabled": true,
							"format": "139",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62,
						"dataLabels": {
							"enabled": true,
							"format": "124",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 59.5,
						"dataLabels": {
							"enabled": true,
							"format": "119",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 49,
						"dataLabels": {
							"enabled": true,
							"format": "98",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 42,
						"dataLabels": {
							"enabled": true,
							"format": "84",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.41791044776119,
						"dataLabels": {
							"enabled": true,
							"format": "646",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.43283582089552,
						"dataLabels": {
							"enabled": true,
							"format": "559",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.8507462686567,
						"dataLabels": {
							"enabled": true,
							"format": "535",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.49253731343283,
						"dataLabels": {
							"enabled": true,
							"format": "479",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62.23880597014926,
						"dataLabels": {
							"enabled": true,
							"format": "417",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.83301343570058,
						"dataLabels": {
							"enabled": true,
							"format": "1009",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.02879078694818,
						"dataLabels": {
							"enabled": true,
							"format": "886",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.28598848368523,
						"dataLabels": {
							"enabled": true,
							"format": "847",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.76007677543186,
						"dataLabels": {
							"enabled": true,
							"format": "779",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 63.43570057581574,
						"dataLabels": {
							"enabled": true,
							"format": "661",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.58633456748571,
						"dataLabels": {
							"enabled": true,
							"format": "2929",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 87.41164591046785,
						"dataLabels": {
							"enabled": true,
							"format": "2597",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.14675193537529,
						"dataLabels": {
							"enabled": true,
							"format": "2500",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.70380343318749,
						"dataLabels": {
							"enabled": true,
							"format": "2368",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.41400201952204,
						"dataLabels": {
							"enabled": true,
							"format": "2092",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -30.500000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.79136690647482,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.0322580645161255,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.647058823529417,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.5820895522388096,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.46749226006192,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.2933810375670785,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.467289719626171,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.943632567849683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.1669865642994233,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.190287413280476,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.401805869074494,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.028335301062572,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.14762516046213,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.4136654325142994,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.334926596107886,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.73507893723527,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.279999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.655405405405405,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=200"
			},
			{
				"x": 9,
				"text": "30–39<br>n=670"
			},
			{
				"x": 15,
				"text": "40–49<br>n=1042"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=2971"
			}
		],
		"dataTable": {
			"< 30": [
				200,
				139,
				124,
				119,
				98,
				84
			],
			"30–39": [
				670,
				646,
				559,
				535,
				479,
				417
			],
			"40–49": [
				1042,
				1009,
				886,
				847,
				779,
				661
			],
			"≥ 50": [
				2971,
				2929,
				2597,
				2500,
				2368,
				2092
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_3.json
// module id = 304
// module chunks = 0